import { TooltipWrapper, TooltipWrapperProps } from '@va/ui/tooltips';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

type DisabledOverlayProps = {
  enabled: boolean;
  containerClassName?: string;
  overlayClassName?: string;
  grayscale?: boolean;
  tooltipProps?: TooltipWrapperProps;
};

export const DisabledOverlay = ({
  containerClassName,
  overlayClassName,
  grayscale = true,
  enabled,
  tooltipProps,
  children,
}: PropsWithChildren<DisabledOverlayProps>) => {
  return (
    <div className={classNames('relative', { grayscale: grayscale && enabled }, containerClassName)}>
      {children}
      {enabled && (
        <TooltipWrapper
          disabled={!enabled || !tooltipProps?.content}
          useDefaultStyle={false}
          placement='cursor'
          shiftCrossAxis
          content={tooltipProps?.content}
          trigger='click'
          {...tooltipProps}
        >
          <div className={classNames('absolute inset-0', overlayClassName)} onClick={(e) => e.stopPropagation()} />
        </TooltipWrapper>
      )}
    </div>
  );
};
